import styles from "./cards.module.scss";
import { BsChatSquareTextFill } from "react-icons/bs";
import { CardProps } from "../../types";


function GreenCard({ children }: CardProps) {
  return (
    <section className={styles.greenCard}>
      <div className={styles.icon}>
        <BsChatSquareTextFill />
      </div>
      {children}
    </section>
  );
}

export default GreenCard;
